var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',[_c('v-btn',{attrs:{"color":"primary darken-1","to":_vm.toContract,"block":"","elevation":"0","id":"dashboard-contractclaim"}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.buttons.submit_contract'))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }